import request from '@/utils/request';
import { obj2query } from '@/utils'


export function createCustomWhitelist(project_uid, plus_uid, data) {
  return request({
    url: `/api/whitelists/projects/${project_uid}/customers/${plus_uid}`,
    method: 'post',
    data
  });
}

export function getCustomWhitelist(project_uid, plus_uid) {
  return request({
    url: `/api/whitelists/projects/${project_uid}/customers/${plus_uid}`,
    method: 'get'
  });
}

export function getCustomWhitelistByUID(uid, plus_uid) {
  return request({
    url: `/api/whitelists/${uid}/customers/${plus_uid}`,
    method: 'get'
  });
}

export function putCustomWhitelistByUID(uid, plus_uid, data) {
  return request({
    url: `/api/whitelists/${uid}/customers/${plus_uid}`,
    method: 'put',
    data
  });
}

export function deleteCustomWhitelistByUID(uid, plus_uid) {
  return request({
    url: `/api/whitelists/${uid}/customers/${plus_uid}`,
    method: 'delete'
  });
}

export function getWhitelistByProjectUID(project_uid) {
  return request({
    url: `/api/whitelists/projects/${project_uid}`,
    method: 'get'
  });
}